import { Router } from '@angular/router';
import { getFormattedDate } from 'src/functions/common-functions';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { AuthService } from '../auth.service';
import { Route } from '@angular/compiler/src/core';
import { MustMatch } from 'src/functions/custom-validators';
import { SINGLE_SELECT_PRESET_VALUE_CONFIG } from '../select-search/presetValueExample.config';
import { AppConstants } from 'src/app/constants';
import { NgxSmartModalService } from 'ngx-smart-modal';
@Component({
  selector: 'app-register-alianza',
  templateUrl: './register-alianza.component.html',
  styleUrls: ['./register-alianza.component.scss'],
})
export class RegisterAlianzaComponent implements OnInit {
  public poliza: number;

  passwordConfirm: boolean;
  mensajeError: any;
  email: string;
  errorMessage: string;
  waitingForApi: boolean;
  ///////////////////////////////////
  formulario_registro_alianza: FormGroup;
  persona: number = 1;
  hoy: Date;
  dateString: string;
  show: boolean = false;
  iguales: boolean = true;
  fecha_valida: boolean = false;
  fecha_valida1: boolean = false;
  fecha_valida2: boolean = false;
  fecha_tocada: boolean = false;
  fecha_tocada2: boolean = false;
  getDate: string;
  showMessage: boolean = false;
  textRFC: string = '';
  edad: number;
  customError: string;
  nacionalidades = [];
  modalMsjError: string = '';

  singleSelectConfig: any = SINGLE_SELECT_PRESET_VALUE_CONFIG;
  siteKey: string = AppConstants.keyCapchat;
  capchat: boolean = true;
  constructor(
    public fb: FormBuilder,
    public authServices: AuthService,
    public route: Router,
    public ngxSmartModalService: NgxSmartModalService
  ) {
    this.mensajeError = '';
    this.passwordConfirm = false;
    this.poliza = 1;
    this.waitingForApi = false;
    this.hoy = new Date();
    this.showMessage = false;
    this.typePerson('1');
  }

  ngOnInit(): void {
    this.authServices.getNacionalidades().subscribe((resp) => {
      this.nacionalidades = [...resp];

      this.nacionalidades.map((e) => {
        e.label = e.desc;
        e.value = e.code;
      });
    });
  }

  get f() {
    return this.formulario_registro_alianza.controls;
  }

  typePerson(e) {
    this.dateString = '';
    this.errorMessage = null;
    this.fecha_valida1 = false;
    this.fecha_valida2 = false;
    this.fecha_tocada = false;
    this.fecha_tocada2 = false;

    switch (e) {
      case '1':
        this.persona = 1;
        this.edad = 18;
        this.capchat = false;
        this.formulario_registro_alianza = this.fb.group(
          {
            rfcFisica: [
              '',
              Validators.compose([
                Validators.required,
                Validators.maxLength(13),
                Validators.minLength(13),
              ]),
            ],
            primerNombre: ['', Validators.required],
            primerApellido: ['', Validators.required],
            nombreComercial: [''],
            email: [
              '',
              Validators.compose([
                Validators.required,
                Validators.email,
                /**
                 * temporalmente se valida para que el correo permita letras mayusculas
                 */
                // Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),]),
                Validators.pattern(
                  '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
                ),
              ]),
            ],
            password1: [
              '',
              Validators.compose([
                Validators.required,
                Validators.minLength(8),
                Validators.pattern(
                  '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
                ),
              ]),
            ],
            password2: [
              '',
              Validators.compose([
                Validators.required,
                Validators.minLength(8),
                Validators.pattern(
                  '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
                ),
              ]),
            ],
            actividadComercial: [''],
            nacionalidad: [''],
            avisoPrivacidad: ['', Validators.required],
            codProveedor: [''],
            recaptcha: [''],
          },
          {
            validator: MustMatch('password1', 'password2'),
          }
        );
        //   this.f.rfc.setErrors(null);
        //   this.f.rfc.setValidators([Validators.required, Validators.minLength(13),Validators.maxLength(13)]);
        // this.f.rfc.updateValueAndValidity();
        break;

      case '2':
        this.persona = 2;
        this.capchat = false;
        this.formulario_registro_alianza = this.fb.group(
          {
            rfcMoral: [
              '',
              Validators.compose([
                Validators.required,
                Validators.maxLength(12),
                Validators.minLength(12),
              ]),
            ],
            nombreComercial: ['', Validators.required],
            razonSocial: ['', Validators.required],
            email: [
              '',
              Validators.compose([
                Validators.required,
                Validators.email,
                /**
                 * temporalmente se valida para que el correo permita letras mayusculas
                 */
                Validators.pattern(
                  '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
                ),
              ]),
            ],
            password1: [
              '',
              Validators.compose([
                Validators.required,
                Validators.minLength(8),
                Validators.pattern(
                  '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
                ),
              ]),
            ],
            password2: [
              '',
              Validators.compose([
                Validators.required,
                Validators.minLength(8),
                Validators.pattern(
                  '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$'
                ),
              ]),
            ],
            nacionalidad: [''],
            avisoPrivacidad: ['', Validators.required],
            codProveedor: [''],
            recaptcha: [''],
          },
          {
            validator: MustMatch('password1', 'password2'),
          }
        );
        //   this.f.rfc.setErrors(null);
        //   this.f.rfc.setValidators([Validators.required, Validators.minLength(12),Validators.maxLength(12)]);
        // this.f.rfc.updateValueAndValidity();
        break;
    }
  }

  switchPass(e) {
    switch (this.show) {
      case true:
        this.show = false;
        break;

      case false:
        this.show = true;
        break;
    }
  }

  calculateAge(fecha_nacimiento) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var birthDate = new Date(fecha_nacimiento);

    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  dateText(e, persona) {
    console.log(e);
    if (persona == 1) {
      this.fecha_tocada = true;
      this.fecha_valida = e.isValid;
      if (this.fecha_valida) {
        let x = moment(e.date, 'DD/MM/YYYY').format('YYYY/MM/DD');
        this.getDate = x.replaceAll('/', '-');
        this.dateString = e.date;

        var newdate = e.date
          .split('/')
          .reverse()
          .join('/')
          .replaceAll('-', '/');

        this.edad = this.calculateAge(newdate);
        if (this.edad < 18) {
          this.fecha_valida1 = false;
        } else {
          this.fecha_valida1 = true;
        }
      }
    }

    if (persona == 2) {
      this.fecha_tocada2 = true;
      this.fecha_valida2 = e.isValid;
      if (this.fecha_valida2) {
        let x = moment(e.date, 'DD/MM/YYYY').format('YYYY/MM/DD');
        this.getDate = x.replaceAll('/', '-');
        this.dateString = e.date;
      }
    }
  }

  test() {
    console.log(this.formulario_registro_alianza.value.avisoPrivacidad);
  }

  Back() {
    this.route.navigate(['/login-alianza']);
  }

  confirmPassword(e: any) {
    if (
      this.formulario_registro_alianza.value.password1 ==
      this.formulario_registro_alianza.value.password2
    ) {
      this.iguales = true;
    } else {
      this.iguales = false;
    }
  }

  createProvider() {
    // console.log(this.formulario_registro_alianza.value);
    // console.log(this.getDate);

    var body;
    const { nacionalidad } = this.formulario_registro_alianza.value;

    switch (this.persona) {
      case 1:
        var nomComercial;

        if (this.formulario_registro_alianza.value.nombreComercial) {
          nomComercial = this.formulario_registro_alianza.value.nombreComercial;
        } else {
          nomComercial =
            this.formulario_registro_alianza.value.primerNombre +
            ' ' +
            this.formulario_registro_alianza.value.primerApellido;
        }

        body = {
          tipoPersona: this.persona,
          rfc: this.formulario_registro_alianza.value.rfcFisica,
          nombre1: this.formulario_registro_alianza.value.primerNombre,
          apellido1: this.formulario_registro_alianza.value.primerApellido,
          nombreComercial: nomComercial,
          fechaNacConst: this.getDate,
          codigoProveedor: parseInt(this.f.codProveedor.value),
          //De momento validacion para que email se envie en minusculas
          email: this.formulario_registro_alianza.value.email.toLowerCase(),
          password: this.formulario_registro_alianza.value.password1,
          passwordConfirmation:
            this.formulario_registro_alianza.value.password2,
          nacionalidad,
        };
        break;

      case 2:
        body = {
          tipoPersona: this.persona,
          rfc: this.formulario_registro_alianza.value.rfcMoral,
          razonSocial: this.formulario_registro_alianza.value.razonSocial,
          nombreComercial:
            this.formulario_registro_alianza.value.nombreComercial,
          fechaNacConst: this.getDate,
          codigoProveedor: parseInt(this.f.codProveedor.value),
          //De momento validacion para que email se envie en minusculas
          email: this.formulario_registro_alianza.value.email.toLowerCase(),
          password: this.formulario_registro_alianza.value.password1,
          passwordConfirmation:
            this.formulario_registro_alianza.value.password2,
          nacionalidad,
        };
        break;
    }

    this.waitingForApi = true;
    this.authServices.registerProvider(body).subscribe(
      (response) => {
        this.waitingForApi = false;
        console.log(response);
        this.showMessage = true;
      },
      (error) => {
        this.waitingForApi = false;
        console.log(error);
        if (error.error.message) {
          this.errorMessage = error.error.message;
        }
        if (error.error.code == 'UNPROCESSABLE_ENTITY') {
          // console.log("Mensaje de error personalizado");
          this.errorMessage = 'Información ya registrada';
        }

        if (error.error.code === 'NOT_FOUND') {
          this.modalMsjError = error.error.data.message;
          this.openModal('errorModalMsj');
        }

        if (error.error.code === 'BAD_REQUEST') {
          this.modalMsjError = error.error.data.message;
          this.openModal('errorModalMsj');
        }
      }
    );
  }

  changeSelectSearch(e) {
    e.touched = true;

    console.log(e);
  }

  switchChange() {
    if (this.formulario_registro_alianza.controls['actividadComercial'].value) {
      this.formulario_registro_alianza.controls[
        'nombreComercial'
      ].setValidators([Validators.required]);
    } else
      this.formulario_registro_alianza.controls[
        'nombreComercial'
      ].clearValidators();

    this.formulario_registro_alianza.controls[
      'nombreComercial'
    ].updateValueAndValidity();
  }

  handleSuccess(e) {
    this.capchat = true;
  }

  handleExpire(e) {
    this.capchat = false;
  }

  closeModal(modal) {
    this.ngxSmartModalService.getModal(modal).close();
  }

  openModal(modal) {
    this.ngxSmartModalService.getModal(modal).open();
  }
}
